import React from 'react';

import DatePicker, { popperModifiers } from '../../common/DatePicker';

import DatePickerInput from './DatePickerInput';
import DropdownHours from './DropdownHours';

import { BasicDrawRecord } from 'Api/SiteApi/Responses';

type Props = Readonly<{
    selectedDate: Date | null;
    onDayChange: (date: Date) => void;
    onMonthChange: (date: Date) => void;
    isDrawAvailable: (date: Date) => boolean;
    draws: BasicDrawRecord[];
    selectedDrawNo: number;
    onSelectDraw: (drawNo: number) => void;
}>;

function ResultsDropdowns({
    selectedDate,
    onDayChange,
    onMonthChange,
    isDrawAvailable,
    draws,
    selectedDrawNo,
    onSelectDraw,
}: Props) {
    const isManyDraws = draws.length > 1;

    return (
        <div className="col-md-auto col-12 row no-gutters justify-content-md-end justify-content-xs-center mt-3 mt-md-0">
            <div className={`dropdown mt-1 ${isManyDraws ? 'mr-3' : ''}`}>
                <div>
                    <DatePicker
                        selected={selectedDate}
                        onChange={onDayChange}
                        onMonthChange={onMonthChange}
                        dayClassName={(date) => (isDrawAvailable(date) ? 'active' : 'disabled-date')}
                        customInput={<DatePickerInput />}
                        dateFormat="dd/MM/yyyy"
                        popperPlacement="bottom-end"
                        maxDate={new Date()}
                        popperModifiers={popperModifiers}
                    />
                </div>
            </div>
            {isManyDraws && <DropdownHours draws={draws} selectedDrawNo={selectedDrawNo} onSelectDraw={onSelectDraw} />}
        </div>
    );
}

export default ResultsDropdowns;
